<div class="lightContent">
  <div class="headingPage">
    <h2 class="">Select Element(Chart)</h2>
  </div>

  <app-all-element-listing
  [types]="'chart'"
  [isPickEnabled]="true"
  (sendIdToParentfn)="elementSelected($event)">
  </app-all-element-listing>

</div>